import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  panel: {
    backgroundColor: 'var(--grey-100)',
    p: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  } satisfies SxProps<Theme>,

  panelHeader: { fontWeight: 600 } satisfies SxProps<Theme>,

  card: {
    backgroundColor: 'var(--white)',
    border: '1px solid var(--border)',
    borderRadius: '6px',
    p: '16px',
    pb: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  } satisfies SxProps<Theme>,

  identity: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px'
  } satisfies SxProps<Theme>,

  avatarWrapper: { position: 'relative' } satisfies SxProps<Theme>,

  avatarEditButton: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    backgroundColor: '#D9D9D9',
    ':hover': { backgroundColor: '#A7A5A5 !important' }
  } satisfies SxProps<Theme>,

  name: { fontWeight: 700 } satisfies SxProps<Theme>,

  fieldRow: { display: 'flex', gap: '10px' } satisfies SxProps<Theme>,

  field: { display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' } satisfies SxProps<Theme>,

  fieldLabel: {
    color: 'var(--grey-900)',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    whiteSpace: 'normal'
  } satisfies SxProps<Theme>,

  fieldInput: {
    '& .MuiOutlinedInput-root': { backgroundColor: 'var(--white)' },
    '& .MuiOutlinedInput-input': { py: '12px', fontFamily: 'Open Sans', fontSize: '14px' },
    // MUI greys helper text out with the disabled field; at 12px that is 2.67:1 and fails WCAG AA.
    '& .MuiFormHelperText-root, & .MuiFormHelperText-root.Mui-disabled': { color: 'var(--grey-500)' }
  } satisfies SxProps<Theme>,

  actions: { display: 'flex', gap: '16px', pt: '8px' } satisfies SxProps<Theme>
}
